<div class="section">
    <div data-qa-id="locums-rec-crna-certification-header" class="nova__label">Board Certification</div>
    <div data-qa-id="locums-rec-crna-certification-value">
        <label *ngIf="!(unitDetails$ | async)?.isNbcrnaCertRequired" data-qa-id="locums-rec-crna-certification-dash">-</label>
        <div class="jd__section__container" *ngIf="(unitDetails$ | async)?.isNbcrnaCertRequired">
            <label data-qa-id="locums-rec-crna-certification-label">
                NBCRNA
            </label>
            <label class="jd__section__emphasized" data-qa-id="locums-rec-crna-certification-detail">
                Required
            </label>
        </div>
    </div>
</div>
